module.exports = __webpack_public_path__ + "static/media/3.93fbb0c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/web/3.png
// module id = 2493
// module chunks = 0